import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { tenantService } from '@/services/tenant.service'
import type { Tenant, UUID } from '@/types/database'

const KEYS = {
    tenants: ['tenants'] as const,
}

export function useTenants() {
    return useQuery({
        queryKey: KEYS.tenants,
        queryFn: () => tenantService.list()
    })
}

export function useCreateTenant() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (data: Partial<Tenant>) => tenantService.create(data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: KEYS.tenants })
    })
}

export function useUpdateTenant() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: ({ id, ...data }: Partial<Tenant> & { id: UUID }) =>
            tenantService.update(id, data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: KEYS.tenants })
    })
}
